//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ViewBox, Group, Cell } from 'vux'
import { WHeader } from '@/components/wx'
import { mapGetters } from 'vuex'

export default {
  name: 'me',
  computed: {
    ...mapGetters('profile', ['name', 'username', 'headIcon'])
  },
  components: {
    ViewBox,
    WHeader,
    Group,
    Cell
  }
}
